import { relationPairs } from "@/mocks/content";
import { Reveal, SectionHeading } from "./common";

const nodes = [
  { name: "河英", role: "姐姐", icon: "ri-user-star-line" },
  { name: "河周", role: "妹妹", icon: "ri-user-heart-line" },
  { name: "宇成", role: "丈夫", icon: "ri-user-line" },
];

export default function Relations() {
  return (
    <section id="relations" className="section-anchor w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
        <Reveal>
          <SectionHeading
            eyebrow="人物关系"
            title="三个人，一张互相牵动的网"
            desc="善良的嫂子人物关系的核心，是家人之间既是依靠、又是压力的双重身份。关系越近，越容易被一句没说出口的话牵动。"
          />
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-8 md:mt-10 rounded-lg bg-background-100 border border-background-200 p-5 md:p-8">
            <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6">
              {nodes.map((node, i) => (
                <div key={node.name} className="flex flex-col md:flex-row items-center gap-4 md:gap-6">
                  <div className="flex flex-col items-center text-center w-32">
                    <span className="service-icon-wrap rounded-full bg-primary-500 text-background-50 flex items-center justify-center">
                      <i className={`${node.icon} text-xl`}></i>
                    </span>
                    <p className="mt-2 font-heading font-semibold text-foreground-950">{node.name}</p>
                    <p className="text-xs text-foreground-500">{node.role}</p>
                  </div>
                  {i < nodes.length - 1 && (
                    <div className="flex md:flex-col items-center gap-1 text-accent-700">
                      <span className="w-px h-6 md:w-14 md:h-px bg-background-300 hidden md:block"></span>
                      <span className="text-[11px] font-label px-2 py-1 rounded-full bg-accent-100 text-accent-800 whitespace-nowrap">
                        {i === 0 ? "姐妹" : "夫妻"}
                      </span>
                      <span className="w-px h-6 md:w-14 md:h-px bg-background-300 hidden md:block"></span>
                      <i className="ri-arrow-right-line md:hidden"></i>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <p className="mt-6 text-center text-xs md:text-sm text-foreground-500">
              三人之间彼此牵制：一方的靠近会牵动另一方的不安，一方的沉默又会放大第三方的猜测。
            </p>
          </div>
        </Reveal>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-5">
          {relationPairs.map((pair, i) => (
            <Reveal key={`${pair.a}-${pair.b}`} delay={i * 60}>
              <div className="h-full rounded-lg bg-background-50 border border-background-200 p-5">
                <div className="flex items-center justify-between gap-3">
                  <p className="font-heading font-semibold text-foreground-950 text-sm md:text-base">
                    {pair.a}
                    <span className="mx-2 text-foreground-400">×</span>
                    {pair.b}
                  </p>
                  <span className="text-[11px] px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-800 whitespace-nowrap">
                    {pair.tag}
                  </span>
                </div>
                <p className="mt-3 text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {pair.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}